import {execute} from './eval.js';

export const pipe =
    (...fns) =>
    (triggers, stepNumber, time, effect) =>
    fns.reduce((input, fn) => execute(fn, input, stepNumber, time, effect), triggers);


